import { Typography } from '@mui/material';
import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material';

interface SectionHeaderProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

function SectionHeader({ children, sx = {} }: SectionHeaderProps) {
  return (
    <Typography
      variant="h5"
      sx={{
        mb: 1,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default SectionHeader;